import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { toggleFinancialTargetGrid } from "actions/financial-target/actions";
import { ColumnApi } from "ag-grid-community";
import { IconButton } from "material-ui";
import React from "react";
import { connect, Dispatch } from "react-redux";
import { IStore } from "reducers";
import { ICollectionState } from "reducers/collection";
import GridControlAlert from "./grid-control-alert";
import { withRouter } from "react-router";
import { View } from "constants/product-collection";
import { Location } from "history";
import "./financial-target-grid-control.css";

interface ReduxProps {
    isGridOpen: boolean;
    columnApi: ColumnApi;
}

interface Props {
    location: Location<{ cartView: View }>;
}

interface ReduxActions {
    toggleFinancialTargetGrid: () => void;
}

const FinancialTargetGridControlComponent = ({
    isGridOpen,
    toggleFinancialTargetGrid,
    columnApi,
    location,
}: ReduxProps & Props & ReduxActions) => {
    const [isPivotAlertOpen, setPivotAlertOpen] = React.useState(false);

    const { query } = location || {};
    const shouldRenderCarrot = query?.cartView !== View.Tile;

    const closeAlert = () => {
        setPivotAlertOpen(false);
    };

    const handleGridControlButtonClick = () => {
        const isPivotEnabled = columnApi?.isPivotMode();

        // Financial target grid doesn't work with the pivot table feature
        // so we alert the user instead of opening the grid
        if (isPivotEnabled && !isGridOpen) {
            setPivotAlertOpen(true);
            return;
        }

        toggleFinancialTargetGrid();
    };

    if (!shouldRenderCarrot) {
        return <div className="financial-target-grid-control-container-placeholder" />;
    }

    return (
        <IconButton onClick={handleGridControlButtonClick} data-test="financial-target-grid-control-button">
            {isGridOpen ? (
                <ExpandMore fontSize="large" data-test="financial-target-grid-controller-open" />
            ) : (
                <ExpandLess fontSize="large" data-test="financial-target-grid-controller-closed" />
            )}
            <GridControlAlert isAlertOpen={isPivotAlertOpen} closeAlert={closeAlert} />
        </IconButton>
    );
};

const mapStateToProps = (store: IStore) => {
    const { financialTarget, collection } = store;
    const { columnApi } = collection as ICollectionState;

    return {
        columnApi,
        isGridOpen: financialTarget.isGridOpen,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
    toggleFinancialTargetGrid: () => dispatch(toggleFinancialTargetGrid()),
});

export const FinancialTargetGridControl = withRouter(
    connect<ReduxProps, ReduxActions, {}>(mapStateToProps, mapDispatchToProps)(FinancialTargetGridControlComponent)
);
